import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.5 0a1 1 0 0 1 1 1v8h5V1a1 1 0 1 1 2 0v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m10 13a1 1 0 0 1 1-1H23a1 1 0 1 1 0 2h-2.5v9a1 1 0 1 1-2 0zM1 12a1 1 0 1 0 0 2h2.5v9a1 1 0 1 0 2 0V13a1 1 0 0 0-1-1zm7.076 6.558A1 1 0 0 1 9 17.94h2V14a1 1 0 1 1 2 0v3.94h2a1 1 0 0 1 .707 1.707l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1-.217-1.09Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TableColAdd = { render };
export {
  TableColAdd as default,
  render
};
//# sourceMappingURL=TableColAdd.svg.js.map
